export default {
      id: "alert-usage",
      viewBox: "0 0 41 41",
      url: "/assets/" + "icons.svg#alert",
      toString: function () {
        return this.url;
      }
    }